import { Box, Flex, Image, useChakraContext, useSlotRecipe } from '@chakra-ui/react';

import { useWpResizer } from '@app/hooks/useWpResizer';

import { FeaturedImageWrapperProps } from './featured-image-wrapper.props';

export const FeaturedImageWrapper = ({
    children,
    isWiderWidth,
    imgUrl,
    href,
    alt,
    ...rest
}: FeaturedImageWrapperProps) => {
    const theme = useChakraContext();
    const recipe = useSlotRecipe({ key: 'featuredImageWrapper' });
    const styles = recipe();

    const wpresizer = useWpResizer();

    const baseWidth = 390;
    const widerWidth = 624;
    const baseHeight = 480;

    const imageSizes = {
        xl: isWiderWidth ? widerWidth : 300,
        lg: baseWidth,
        md: 460,
        sm: 510,
    };

    const breakpoints = Object.keys(imageSizes) as (keyof typeof imageSizes)[];

    const sourceData = breakpoints.map(breakpoint => ({
        size: imageSizes[breakpoint],
        breakpointValue: theme.breakpoints.values.find(b => b.name === breakpoint)?.min,
    }));

    return (
        <Flex css={styles.container} {...rest}>
            <Flex css={styles.linkWrapper} asChild>
                <a href={href}>
                    <Box as="picture" css={styles.mask}>
                        {sourceData?.map((el, index) => (
                            <source
                                key={index}
                                srcSet={wpresizer([el.size, baseHeight], imgUrl)}
                                media={`(min-width: ${el.breakpointValue})`}
                            />
                        ))}
                        <Image
                            src={imgUrl && wpresizer([baseWidth, baseHeight], imgUrl)}
                            htmlWidth={baseWidth}
                            htmlHeight={baseHeight}
                            height={baseHeight}
                            loading="lazy"
                            css={styles.image}
                            alt={alt}
                        />
                    </Box>
                </a>
            </Flex>
            <Flex css={styles.contentWrapper}>{children}</Flex>
        </Flex>
    );
};
